import { action, createRequestTypes } from './base';

export const paymentRequestActionTypes = {
  GET_PAYMENT_REQUEST: createRequestTypes('GET_PAYMENT_REQUEST'),
  CREATE_PAYMENT_REQUEST: createRequestTypes('CREATE_PAYMENT_REQUEST'),
  UPDATE_PAYMENTS_REQUEST: createRequestTypes('UPDATE_PAYMENTS_REQUEST'),
};

/**
 * PaymentOutgoingActions class
 *
 * @param payload
 * @param callback
 */
class PaymentRequestActions {
  /**
   * @param {*} page
   * @param {*} limit
   * @param {*} tenantId
   * @param tenantSellerId
   * @param {*} paymentId
   * @return
   */
  getPaymentRequest = (page, limit, tenantId) => action(paymentRequestActionTypes.GET_PAYMENT_REQUEST.REQUEST, {
    page, limit, tenantId,
  });

  /**
   * @param getPaymentRequestLoading
   * @return {{type: *}}
   */
   getPaymentRequestLoading = (getPaymentRequestLoading) => action(paymentRequestActionTypes.GET_PAYMENT_REQUEST.LOADING, {
     getPaymentRequestLoading,
   });

   /**
    * @param payments
    * @param {*} paymentOutgoing
    * @return
    */
   getPaymentRequestSuccess = (payments) => action(paymentRequestActionTypes.GET_PAYMENT_REQUEST.SUCCESS, {
     payments,
   });

  /**
   *
   * @type {{type: *}}
   */
  createPaymentRequest = (payload, callback) => action(paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.REQUEST, {
    payload,
    callback,
  });

  /**
   * @param createPaymentRequestLoading
   * @return {{type: *}}
   */
   createPaymentRequestLoading = (createPaymentRequestLoading) => action(paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.LOADING, {
     createPaymentRequestLoading,
   });

   /**
    *
    * @type {{type: *}}
    */
    updatePaymentRequest = (payload, callback) => action(paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.REQUEST, {
      payload,
      callback,
    });

    /**
     * @param updatePaymentRequestLoading
     * @param createPaymentRequestLoading
     * @return {{type: *}}
     */
     updatePaymentRequestLoading = (updatePaymentRequestLoading) => action(paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.LOADING, {
       updatePaymentRequestLoading,
     });
}

export default new PaymentRequestActions();
